import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import ReferencesPage from "@/pages/ReferencesPage";
import ContactPage from "@/pages/ContactPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/referenzen" element={<ReferencesPage />} />
                    <Route path="/kontakt" element={<ContactPage />} />
                    <Route path="/impressum" element={<ImpressumPage />} />
                    <Route path="/datenschutz" element={<DatenschutzPage />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-right"
                theme="light"
                toastOptions={{
                    style: {
                        background: "#FEFEFE",
                        color: "#14100D",
                        border: "1px solid rgba(20,16,13,0.1)",
                        borderRadius: "2px",
                    },
                }}
            />
        </div>
    );
}

export default App;
